module.exports = __webpack_public_path__ + "img/demo_2.9566c25a.png";